import { Component } from '@theme/component';

/**
 * Builds an "In This Story" jump-list from the article body's own H2
 * subheadings. Stays hidden when there are fewer than 2 H2s to jump between.
 *
 * @typedef {object} Refs
 * @property {HTMLOListElement} list
 *
 * @extends Component<Refs>
 */
export default class StoryToc extends Component {
  connectedCallback() {
    super.connectedCallback();

    const section = this.closest('.shopify-section');
    const headings = section?.querySelectorAll('.blog-post-content .rte h2') ?? [];
    if (headings.length < 2) return;

    const { list } = this.refs;
    if (!list) return;

    headings.forEach((heading, index) => {
      const id = `story-heading-${index + 1}`;
      heading.id = id;

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${id}`;
      link.textContent = heading.textContent?.trim() ?? '';
      item.append(link);
      list.append(item);
    });

    this.removeAttribute('hidden');
  }
}

if (!customElements.get('story-toc')) {
  customElements.define('story-toc', StoryToc);
}
